module.exports = __webpack_public_path__ + "static/media/PV.2b8cffc1.png";